import { render, staticRenderFns } from "./DistributeInitiativeModal.vue?vue&type=template&id=918e752e"
import script from "./DistributeInitiativeModal.vue?vue&type=script&lang=ts"
export * from "./DistributeInitiativeModal.vue?vue&type=script&lang=ts"
import style0 from "./DistributeInitiativeModal.vue?vue&type=style&index=0&id=918e752e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports